import {classNames, layout, typography} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {AWESOME_BAR_ZINDEX} from "../common";
import {BarcodeTool} from "./BarcodeTool";
import {DoorbellTool} from "./DoorbellTool";
import {KeypadTool} from "./KeypadTool";
import {LockingTool} from "./LockingTool";
import {NfcReaderTool} from "./NfcReaderTool";
import {PagerTool} from "./PagerTool";
import {PaymentTerminalTool} from "./PaymentTerminalTool";
import {MockProps} from "./types";

export function MockTools({mockController}: MockProps) {
	return (
		<div className={styles.mockTools}>
			<div className={classNames(layout.paddingSmall, typography.muted)}>
				MOCK<br />TOOLS
			</div>
			<LockingTool mockController={mockController} align="left" />
			<PagerTool mockController={mockController} align="left" />
			<BarcodeTool mockController={mockController} align="left" />
			<KeypadTool mockController={mockController} align="left" />
			<PaymentTerminalTool mockController={mockController} align="right" />
			<NfcReaderTool mockController={mockController} align="right" />
			<DoorbellTool mockController={mockController} align="right" />
		</div>
	);
}

const styles = stylesheet({
	mockTools: {
		position: "fixed",
		height: "3em",
		bottom: 0,
		left: 0,
		width: "100%",
		background: "rgba(0, 0, 0, 0.5)",
		color: "#ddd",
		display: "flex",
		flexFlow: "row nowrap",
		zIndex: AWESOME_BAR_ZINDEX,
	},
});
